const COLORS = {
  primary: "rgb(31, 58, 112)",
  text: "#111827",
  textLight: "#6b7280",
  border: "#e5e7eb",
  background: "#f9fafb",
  backgroundLight: "#eef2f7",
  white: "#ffffff",
  success: "#22c55e",
  error: "#ef4444",
  blue: "#3b82f6",
};

export const styles = {
  container: (isMobile) => ({
    padding: isMobile ? 16 : 28,
    flex: 1,
    minHeight: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    overflowY: "auto",
    background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
  }),

  headerSection: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    gap: 14,
    marginBottom: 20,
  }),

  iconBadge: {
    width: 48,
    height: 48,
    borderRadius: 14,
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    boxShadow: "0 16px 32px rgba(31, 58, 112, 0.14)",
  },

  titleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    marginBottom: 12,
  },

  formWrapper: (isMobile) => ({
    backgroundColor: COLORS.white,
    borderRadius: isMobile ? 18 : 22,
    boxShadow: "0 20px 50px rgba(34, 60, 80, 0.08)",
    border: "1px solid rgba(31, 58, 112, 0.08)",
    padding: isMobile ? 20 : 28,
    width: "100%",
    boxSizing: "border-box",
  }),

  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: "700",
    color: COLORS.text,
  },

  subtitle: {
    margin: "6px 0 0",
    fontSize: 14,
    color: COLORS.textLight,
    lineHeight: 1.5,
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    marginTop: 24,
  },

  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: COLORS.text,
  },

  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 6,
    border: `1px solid ${COLORS.border}`,
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    backgroundColor: COLORS.background,
    color: COLORS.text,
    boxSizing: "border-box",
  },

  passwordInputWrapper: {
    position: "relative",
    width: "100%",
  },

  passwordToggleButton: {
    position: "absolute",
    top: "50%",
    right: 12,
    transform: "translateY(-50%)",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    color: COLORS.textLight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 6,
  },

  select: {
    padding: "12px 14px",
    borderRadius: 6,
    border: `1px solid ${COLORS.border}`,
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    backgroundColor: COLORS.white,
    color: COLORS.text,
    cursor: "pointer",
    width: "100%",
    boxSizing: "border-box",
  },

  selectContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  selectedPreview: {
    padding: "10px 14px",
    borderRadius: 8,
    background: `linear-gradient(135deg, ${COLORS.primary}, #3d5bb8)`,
    color: COLORS.white,
    display: "flex",
    alignItems: "center",
    gap: 10,
    fontSize: "14px",
    fontWeight: "600",
  },

  selectWithIcons: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 10,
  },

  selectOption: {
    padding: "12px 14px",
    borderRadius: 8,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.white,
    color: COLORS.text,
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  selectOptionActive: {
    borderColor: COLORS.primary,
    background: `linear-gradient(135deg, ${COLORS.primary}, #3d5bb8)`,
    color: COLORS.white,
    boxShadow: "0 8px 16px rgba(31, 58, 112, 0.16)",
  },

  photoSection: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    alignItems: "center",
  },

  photoPreviewWrapper: (isMobile) => ({
    position: "relative",
    width: "100%",
    maxWidth: isMobile ? "100%" : 200,
  }),

  photoPreview: (isMobile) => ({
    width: "100%",
    height: isMobile ? 180 : 200,
    borderRadius: 8,
    objectFit: "cover",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  }),

  removePhotoButton: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: COLORS.error,
    color: COLORS.white,
    border: "none",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
  },

  photoPlaceholder: {
    width: "100%",
    minHeight: 140,
    borderRadius: 8,
    border: `2px dashed ${COLORS.border}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: COLORS.background,
  },

  uploadIcon: {
    width: 40,
    height: 40,
    color: COLORS.textLight,
    marginBottom: 8,
  },

  photoPlaceholderText: {
    margin: 0,
    fontSize: "13px",
    color: COLORS.textLight,
    textAlign: "center",
  },

  hiddenFileInput: {
    display: "none",
  },

  fileInputLabel: {
    padding: "8px 16px",
    borderRadius: 6,
    backgroundColor: COLORS.blue,
    color: COLORS.white,
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "600",
    transition: "background-color 0.2s ease",
    border: "none",
  },

  errorText: {
    fontSize: "12px",
    color: COLORS.error,
    fontWeight: "500",
  },

  customSelect: {
    position: "relative",
    width: "100%",
  },

  selectBox: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: 6,
    border: `1px solid ${COLORS.border}`,
    fontSize: "14px",
    color: COLORS.text,
    backgroundColor: COLORS.background,
    cursor: "pointer",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: 8,
    boxSizing: "border-box",
    userSelect: "none",
  },

  dropdown: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: COLORS.white,
    border: `1px solid ${COLORS.border}`,
    borderTop: "none",
    borderRadius: "0 0 6px 6px",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    maxHeight: 200,
    overflowY: "auto",
    marginTop: -1,
  },

  option: {
    padding: "12px 14px",
    cursor: "pointer",
    transition: "background-color 0.15s ease",
    color: COLORS.text,
    display: "flex",
    alignItems: "center",
    gap: 8,
    borderBottom: `1px solid ${COLORS.border}`,
    fontSize: "14px",
  },

  optionHover: {
    backgroundColor: COLORS.background,
  },

  optionGroup: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 12,
  },

  optionButton: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 8,
    border: `1px solid ${COLORS.border}`,
    background: COLORS.white,
    color: COLORS.text,
    cursor: "pointer",
    transition: "all 0.25s ease",
    textAlign: "left",
    fontWeight: "600",
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    fontSize: "14px",
  },

  optionButtonActive: {
    borderColor: COLORS.primary,
    background: `linear-gradient(135deg, ${COLORS.primary}, #3d5bb8)`,
    color: COLORS.white,
    boxShadow: "0 8px 16px rgba(31, 58, 112, 0.16)",
  },

  optionButtonIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  textarea: {
    width: "100%",
    minHeight: 120,
    padding: "12px 14px",
    borderRadius: 6,
    border: `1px solid ${COLORS.border}`,
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    backgroundColor: COLORS.background,
    color: COLORS.text,
    boxSizing: "border-box",
    fontFamily: "inherit",
    resize: "vertical",
    lineHeight: 1.5,
  },

  buttonGroup: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: 12,
    marginTop: 8,
  }),

  cancelButton: (isMobile) => ({
    flex: 1,
    width: isMobile ? "100%" : "auto",
    padding: "12px 16px",
    borderRadius: 6,
    border: `1px solid ${COLORS.border}`,
    backgroundColor: COLORS.background,
    color: COLORS.text,
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  }),

  submitButton: (isMobile) => ({
    flex: 1,
    width: isMobile ? "100%" : "auto",
    padding: "12px 16px",
    borderRadius: 6,
    border: "none",
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  }),
  

  iaListHeader: {
    display: "flex",
    padding: "10px 18px",
    fontSize: "12px",
    fontWeight: 700,
    color: COLORS.textLight,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    borderBottom: `1px solid ${COLORS.border}`,
    background: COLORS.backgroundLight,
    borderTopLeftRadius: 14,
    borderTopRightRadius: 14,
  },

  iaRow: {
    display: "flex",
    alignItems: "center",
    padding: "14px 18px",
    borderBottom: `1px solid ${COLORS.border}`,
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    background: COLORS.white,
  },

  iaRowHover: {
    backgroundColor: COLORS.backgroundLight,
  },

  iaColName: {
    flex: 2,
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
  },

  iaAvatar: {
    width: 36,
    height: 36,
    borderRadius: 10,
    objectFit: "cover",
    border: `1px solid ${COLORS.border}`,
    flexShrink: 0,
  },

  iaAvatarFallback: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: COLORS.backgroundLight,
    display: "grid",
    placeItems: "center",
    color: COLORS.textLight,
    border: `1px solid ${COLORS.border}`,
    flexShrink: 0,
  },

  iaColText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },

  iaName: {
    fontSize: 14,
    fontWeight: 700,
    color: COLORS.text,
    margin: 0,
  },

  iaDesc: {
    fontSize: 12,
    color: COLORS.textLight,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  iaColFunction: {
    flex: 1,
    fontSize: 13,
    color: COLORS.textLight,
  },

  iaColTag: {
    flex: 1,
  },

  iaColDate: {
    flex: 1,
    textAlign: "right",
    fontSize: 12,
    fontWeight: 600,
    color: COLORS.primary,
  },

  tagBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    background: "rgba(31, 58, 112, 0.12)",
    color: COLORS.primary,
  }
  

};
